import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import Paper from "@material-ui/core/Paper";
import { connect } from "react-redux";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import { getCourseStats } from "../../redux/actions";
import { secsToStr } from "../../tools";
import { showSpinner, hideSpinner } from "../../redux/actions";
import Autocomplete from "@material-ui/lab/Autocomplete";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing(3),
    overflowX: "auto",
  },
  autocomplete: {
    width: 320,
    marginRight: 8,
  },
  inputWrap: {
    padding: 16,
    display: "flex",
    alignItems: "center",
  },
  textFiled: {
    width: 350,
    marginRight: 8,
  },
  table: {
    minWidth: 650,
    "& th": {
      border: "1px solid #ccc",
      padding: "0.35em",
      backgroundColor: "#efefef",
      color: "#666",
    },
    "& td": {
      textAlign: "center",
      padding: "0.35em 1em",
    },
    "& td:first-child": {
      textAlign: "left",
    },
    "& tr": {
      borderBottom: "1px solid #eee",
    },
    "& tr:hover": {
      backgroundColor: "#eee",
    },
  },
  [`@media (max-width: ${800}px)`]: {
    inputWrap: {
      display: "block",
    },
    autocomplete: {
      marginBottom: 8,
    },
    textFiled: {
      marginBottom: 8,
    },
  },
}));

function Row(props) {
  const {
    title,
    presentationSeconds,
    activationSeconds,
    evaluationSeconds,
    supplementSeconds,
    overallSeconds,
    attempts,
  } = props.stats;
  return (
    <tr>
      <td>{title}</td>
      <td>{secsToStr(overallSeconds, "h?:mm:ss")}</td>
      <td>
        {presentationSeconds !== undefined
          ? secsToStr(presentationSeconds, "h?:mm:ss")
          : "-"}
      </td>
      <td>
        {activationSeconds !== undefined
          ? secsToStr(activationSeconds, "h?:mm:ss")
          : "-"}
      </td>
      <td>
        {evaluationSeconds !== undefined
          ? secsToStr(evaluationSeconds, "h?:mm:ss")
          : "-"}
      </td>
      <td>
        {supplementSeconds !== undefined
          ? secsToStr(supplementSeconds, "h?:mm:ss")
          : "-"}
      </td>
      <td>{attempts}</td>
    </tr>
  );
}

var emailRegex =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

function SimpleTable(props) {
  const classes = useStyles();
  const { viewUserReports, courses, currentCourseId } = props;
  const [course, setCourse] = useState(null);
  const [email, setEmail] = useState("");

  useEffect(() => {
    const course = courses.find((c) => (c.id = currentCourseId));
    if (course) setCourse(course);
    props.getCourseStats();
    // eslint-disable-next-line
  }, []);

  const renderEmail = () => {
    const onChange = (ev) => setEmail(ev.target.value);
    const onClick = () => {
      props.getCourseStats(course.id, email.trim());
    };
    return (
      <div className={classes.inputWrap}>
        <Autocomplete
          options={courses}
          getOptionLabel={(option) => option.title}
          value={course}
          onChange={(ev, val) => setCourse(val)}
          className={classes.autocomplete}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Kurs"
              variant="outlined"
              size="small"
              error={!course}
            />
          )}
        />
        <TextField
          value={email}
          onChange={onChange}
          label="E-mail użytkownika"
          variant="outlined"
          size="small"
          className={classes.textFiled}
          error={!email.match(emailRegex)}
        />
        <Button
          variant="outlined"
          color="secondary"
          onClick={onClick}
          disabled={!email.match(emailRegex) || !course}
          className={classes.btn}
        >
          Pokaż statystyki
        </Button>
      </div>
    );
  };

  return (
    <Paper className={classes.root}>
      {viewUserReports && renderEmail()}
      <Table className={classes.table}>
        <thead>
          <tr>
            <th rowSpan="2">Odcinek / Zestaw gier</th>
            <th colSpan="5">Czas pracy</th>
            <th rowSpan="2">Podejścia</th>
          </tr>
          <tr>
            <th>Całość</th>
            <th>Prezentacja</th>
            <th>Aktywacja</th>
            <th>To już potrafię</th>
            <th>Suplement</th>
          </tr>
        </thead>
        <tbody>
          {props.stats.data.map((stats, idx) => (
            <Row stats={stats} key={idx} />
          ))}
        </tbody>
      </Table>
    </Paper>
  );
}

const mapStateToProps = (state) => {
  return {
    stats: state.stats.courseStats,
    viewUserReports: state.auth.viewUserReports,
    courses: state.courses,
    currentCourseId: state.course.id,
  };
};

export default connect(mapStateToProps, {
  getCourseStats,
  showSpinner,
  hideSpinner,
})(SimpleTable);
